import React from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'
import Heading from 'app/React/ProductForm/Heading'
import VariationPicker from 'app/React/ProductForm/VariantPicker'
import AmountCalculator from 'app/React/ProductForm/AmountCalculator'
import Description from 'app/React/ProductForm/Description'
import ProductText from 'app/React/ProductForm/ProductText'
import Footer from 'app/React/ProductForm/Footer'
import Planting from 'app/React/Planting/Planting'
import TypePicker from 'app/React/ProductForm/TypePicker'
import ProductModal from 'app/React/ProductForm/ProductModal'

function ProductForm(props){
  const [product] = useEnvValue('product')
  const [shouldRender] = useEnvValue('planting.shouldRender',false)

  const planting = shouldRender === true ? <Planting/> : ''

  return(
    <>
      <Heading product={product} excludeTitle={props.excludeTitle}/>
      <Description/>
      <ProductText/>
      <TypePicker/>
      <ProductModal/>
      <VariationPicker/>
      {planting}
      <AmountCalculator/>
      <Footer/>
    </>
  )
}
ProductForm.defaultProps = {
  excludeTitle: false
}
export default observer(ProductForm)